/**
 * What this bundle is: the product version it was built at, the commit it was built from, and
 * when. The values are substituted into the bundle at build time by `buildInfoDefine` (see
 * ../vite.js), so nothing is read at runtime and there is no request to make.
 *
 * Deliberately not a `VITE_*` environment variable, which is how every other build-time value
 * reaches these apps. Those live in `apps/*\/.env`, which is gitignored — a clean clone has none,
 * and Vite treats a missing env file as an empty one rather than an error (known gap 8). A version
 * sourced that way would read as blank in exactly the situation where somebody is trying to work
 * out what they are running. `version.json` is committed, so it cannot go missing.
 */

export interface BuildInfo {
  /** Which SPA this is, e.g. `admin-web`. */
  app: string;
  /** The product version, shared with the API and the other two SPAs. */
  version: string;
  /** Full commit SHA, or null where the build had no checkout to read one from. */
  commit: string | null;
  /** ISO 8601, UTC. */
  builtAt: string;
}

declare const __BRUSH_BUILD_INFO__: BuildInfo;

/**
 * If this throws `__BRUSH_BUILD_INFO__ is not defined`, the app's `vite.config.ts` is missing its
 * `buildInfoDefine(...)` spread into `define`. Loud on purpose: the alternative is a placeholder
 * that reads like a real answer.
 */
export const buildInfo: BuildInfo = __BRUSH_BUILD_INFO__;

/**
 * Seven characters, the length git itself abbreviates to. Shortening is a display decision, which
 * is why the API reports the full SHA and this happens here.
 */
export function shortCommit(commit: string | null | undefined): string | null {
  if (!commit) return null;
  return commit.slice(0, 7);
}
